import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
    isLoading: false,
    error: null,
    suppliers: [],
    supplier: null,
};

const slice = createSlice({
    name: "supplier",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        getSuppliersSuccess(state, action) {
            state.isLoading = false;
            state.suppliers = action.payload;
        },

        getSupplierSuccess(state, action) {
            state.isLoading = false;
            state.supplier = action.payload;
        },
    },
});

export default slice.reducer;

export function getSuppliers(warehouseId) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(
                `${backendUrl}/supplier?warehouseId=${warehouseId}&isDeleted=false&limit=10000000`
            );
            dispatch(slice.actions.getSuppliersSuccess(response.data.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSupplier(supplierId) {
    return (dispatch, getState) => {
        const supplierList = getState().supplier.suppliers;
        const foundSupplier = supplierList.find(s => s.id === supplierId);

        if (foundSupplier) {
            dispatch(slice.actions.getSupplierSuccess(foundSupplier));
        } else {
            dispatch(slice.actions.hasError("Supplier not found in local state."));
        }
    };
}
